import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import TableContainer from '../../common/Tablecontainer'; // 💡 Synergizes architecture layers safely

const CourseReport = () => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
  
    
    // 💡 Dynamic master dropdown configuration states
    const [dynamicCourses, setDynamicCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState('All');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [tableKey, setTableKey] = useState(0);
    const [list, setList] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);

    const [mobilePage, setMobilePage] = useState(1);
    const [mobileTotalPages, setMobileTotalPages] = useState(1);

    const [isMobile, setIsMobile] = useState(
        window.innerWidth < 768
    );

    useEffect(() => {

        const resize = () => {

            setIsMobile(window.innerWidth < 768);

        };

        window.addEventListener(
            "resize",
            resize
        );

        return () =>
            window.removeEventListener(
                "resize",
                resize
            );

    }, []);
    const loadCourseReport = async (
        page = mobilePage,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const res = await API.get(
                "admin/course-report/",
                {

                    params: {

                        page,

                        search,

                        courseId: selectedCourse,

                        fromDate,

                        toDate,

                        type: "All"

                    }

                }
            );

            setList(res.data.results || []);

            setMobileTotalPages(

                Math.ceil(

                    (res.data.count || 0) / 10

                )

            );

        }

        finally {

            setLoadingCards(false);

        }

    };
    // ─── 💡 STEP 1: FETCH DYNAMIC MASTER COURSES LIST FROM DATABASE ───
    const loadMasterCoursesDropdown = async () => {
        try {
            
            const res = await API.get('course-master/');
            setDynamicCourses(res.data);
        } catch (err) {
            console.error("Failed to load master courses list setup framework:", err);
        }
    };

    // ─── 💡 STEP 2: FETCH LEDGER COURSE REPORT DATA ───
    const handleFetchReportAction = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        try {
            const res = await API.get(`admin/course-report/`, {
                params: {
                    courseId: selectedCourse, // Mapped seamlessly with dynamic selector keys
                    fromDate: fromDate || '',  
                    toDate: toDate || ''      
                }
            });
            setReportData(res.data);
            if (isMobile) {

                setMobilePage(1);

                loadCourseReport(
                    1,
                    searchQuery
                );

            }
            setTableKey(prev => prev + 1);
        } catch (err) {
            console.error("Failure communicating network evaluation query sets:", err);
            toast.error("API failed to harvest course report logs matrix.");
        } finally {
            setLoading(false);
        }
    };

    // Component mounts Frame execution hooks
    useEffect(() => {
        loadMasterCoursesDropdown(); // Loads dynamic options matrix first
    }, []);

    // ─── 💡 AUTO-RELOAD TRIGGER MATRIX ON DROPDOWN CHANGE ───
    useEffect(() => {
        handleFetchReportAction();
    }, [selectedCourse]); 
    useEffect(() => {

        if (!isMobile) return;

        loadCourseReport(
            1,
            searchQuery
        );

    }, []);

    useEffect(() => {

        if (!isMobile) return;

        const timer = setTimeout(() => {

            setMobilePage(1);

            loadCourseReport(
                1,
                searchQuery
            );

        }, 400);

        return () => clearTimeout(timer);

    }, [
        searchQuery,
        selectedCourse,
        fromDate,
        toDate
    ]);

    useEffect(() => {

        if (!isMobile) return;

        loadCourseReport(
            mobilePage,
            searchQuery
        );

    }, [mobilePage]);

    // Header layout configurations matching blueprint sequence matching perfectly
    const gridHeaders = ['Name', 'Course Name', 'Mobile No', 'Email Id', 'Course Activated', 'Amount', 'Duration'];

    const handlePrintGridAction = () => {
        window.print();
    };

    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans print:p-0 select-none animate-fadeIn">
            <div className="w-full max-w-8xl mx-auto flex flex-col space-y-6 px-2">
                
                {/* Header Title Section (Hidden during print execution) */}
                <div className="w-full text-center print:hidden">
                    <h2 className="text-center text-4xl font-light text-gray-700 mb-4 tracking-tight">
                        Course Report
                    </h2>
                </div>

                {/* ─── BLOCK 1: PARAMETERS SELECTOR CONTROLS BOX (Hidden during print) ─── */}
                <form onSubmit={handleFetchReportAction} className="w-full bg-white border border-gray-300 px-6 pb-6 pt-2 rounded relative shadow-sm flex flex-col space-y-4 print:hidden">
                    
                    {/* Floating Left Tag Label Fieldset Indicator */}
                    <span className="absolute -top-2.5 left-4 bg-[#F8FAFC] px-2 text-[11px] font-bold text-gray-700 tracking-wide">
                        Course Report
                    </span>
                    
                    {/* Synchronized 3-Column Grid Grid Container Layout */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center text-xs font-bold uppercase text-gray-700 pt-4 w-full">
                        
                        {/* Dynamic Course Dropdown Input Selector */}
                        <div className="
                        flex
                        flex-col
                        md:flex-row
                        gap-2
                        ">
                            <label className="w-full md:w-[30%] text-left md:text-right pr-2">Select Course(<span className="text-red-500">*</span>) :</label>
                            <select 
                                className="flex-1 p-2 border border-gray-300 rounded-md outline-none bg-gray-50 font-bold text-[#032167] cursor-pointer hover:border-blue-400 h-9 transition-all shadow-sm"
                                value={selectedCourse}
                                onChange={(e) => setSelectedCourse(e.target.value)}
                            >
                                <option value="All">All Registered Courses</option>
                                {/* 💡 Renders database driven categories lines dynamically */}
                                {dynamicCourses.map(course => (
                                    <option key={course.id} value={course.id}>{course.name}</option>
                                ))}
                            </select>
                        </div>

                        {/* From Date Input Field control */}
                        <div className="flex items-center gap-2">
                            <label className="w-full md:w-[30%] text-left md:text-right  pr-2">From Date(<span className="text-red-500">*</span>) :</label>
                            <input 
                                type="date"
                                className="flex-1 p-2 border border-gray-300 rounded-md outline-none bg-gray-50 font-semibold text-gray-700 hover:border-blue-400 h-9 transition-all shadow-sm"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </div>

                        {/* To Date Input Field control */}
                        <div className="flex items-center gap-2">
                            <label className="w-full md:w-[30%] text-left md:text-right  pr-2">To Date(<span className="text-red-500">*</span>) :</label>
                            <input 
                                type="date"
                                className="flex-1 p-2 border border-gray-300 rounded-md outline-none bg-gray-50 font-semibold text-gray-700 hover:border-blue-400 h-9 transition-all shadow-sm"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                            />
                        </div>

                    </div>

                    {/* Central Button Operational Row Dispatch Block */}
                    <div
                    className="
                    flex
                    flex-col
                    md:flex-row
                    justify-center
                    gap-3
                    pt-4
                    border-t
                    "
                    >
                        <button 
                            type="submit" 
                            className="w-full md:w-auto px-12 py-2  bg-[#2563EB] text-white text-xs font-bold uppercase tracking-wider rounded-md hover:bg-blue-800 transition-all cursor-pointer border-none shadow-md active:scale-95"
                        >
                            Search 
                        </button>
                    </div>
                </form>

                {/* ─── BLOCK 2: DATA GRID Area ─── */}
                <div className="w-full bg-white rounded-xl shadow-sm overflow-visible md:overflow-hidden border border-gray-300 flex flex-col">
                    
                    {/* <div className="w-full p-2.5 bg-white border-b border-gray-300 flex justify-end items-center print:hidden">
                        <button 
                            type="button"
                            onClick={handlePrintGridAction}
                            className="px-6 py-1.5 bg-[#2563EB] text-white font-semibold text-xs tracking-wide rounded hover:bg-blue-800 transition-colors cursor-pointer border-none shadow-md active:scale-95"
                        >
                            Print
                        </button>
                    </div> */}
                    <div className="hidden md:block">

                    <TableContainer
                        columns={gridHeaders}
                        apiUrl="admin/course-report/"
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                       
                        searchPlaceholder="Type name or email to filter inside active grid instantly..."
                        customActions={
                            <button 
                                type="button"
                                onClick={handlePrintGridAction}
                                className="px-6 py-1.5 bg-[#2563EB] text-white font-semibold text-xs tracking-wide rounded hover:bg-blue-800 transition-colors cursor-pointer border-none shadow-md active:scale-95">
                                Print
                            </button>
                        }
                        renderRow={(item, index, srNo) => (
                            <tr key={item.id || index} className="border-b border-gray-200 hover:bg-gray-50/80 transition-colors h-auto text-gray-700 text-xs font-medium bg-white">
                                <td className="py-3 px-2 border-r bg-gray-50/30 font-bold text-gray-400 w-[5%] text-center select-none">{srNo}</td>
                                <td className="py-3 px-2 border-r text-left pl-4 font-bold text-gray-800 tracking-wide uppercase">{item.user_name || '-'}</td>
                                <td className="py-3 px-2 border-r text-left pl-4 font-semibold text-[#032167] uppercase">{item.course_name || '-'}</td>
                                <td className="py-3 px-2 border-r text-center font-semibold text-gray-600 tracking-normal">{item.mobileno || '-'}</td>
                                <td className="py-3 px-2 border-r text-left pl-4 text-blue-600 lowercase font-mono">{item.emailid || '-'}</td>
                                <td className="py-3 px-2 border-r text-center font-bold text-teal-600 tracking-tight">{item.course_activated || '-'}</td>
                                <td className="py-3 px-2 border-r text-center font-bold text-gray-800 tracking-wide">₹{item.amount || '-'}</td>
                                <td className="py-3 px-2 text-center font-semibold text-gray-500 normal-case">{item.duration ? `${item.duration} Days` : '-'}</td>
                            </tr>
                        )}
                    />
                    </div>
                    <div className="md:hidden mt-4">

                    <input

                    type="text"

                    value={searchQuery}

                    onChange={(e)=>setSearchQuery(e.target.value)}

                    placeholder="Search Course..."

                    className="
                    w-full
                    border
                    rounded-lg
                    p-3
                    text-sm
                    outline-none
                    "

                    />

                    </div>
                    <div className="md:hidden space-y-4 mt-4">

                    {

                    loadingCards ?

                    <div className="text-center py-10">

                    Loading...

                    </div>

                    :

                    list.length===0 ?

                    <div className="text-center py-10">

                    No Record Found

                    </div>

                    :

                    list.map((item)=>(

                    <div

                    key={item.id}

                    className="
                    bg-white
                    rounded-xl
                    border
                    shadow-sm
                    p-4
                    w-full
                    max-w-full
                    min-w-0
                    overflow-hidden
                    "

                    >

                    <div className="space-y-3">

                    <div>

                    <p className="text-xs text-gray-500">

                    Name

                    </p>

                    <p className="font-bold">

                    {item.user_name}

                    </p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Course

                    </p>

                    <p>

                    {item.course_name}

                    </p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Mobile

                    </p>

                    <p>

                    {item.mobileno}

                    </p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Email

                    </p>

                    <p className="break-all text-blue-600">

                    {item.emailid}

                    </p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Activated

                    </p>

                    <p>

                    {item.course_activated}

                    </p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Amount

                    </p>

                    <p>

                    ₹ {item.amount}

                    </p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Duration

                    </p>

                    <p>

                    {item.duration} Days

                    </p>

                    </div>

                    </div>

                    </div>

                    ))

                    }

                    </div>
                    <div className="md:hidden flex justify-between items-center py-5">

                    <button

                    disabled={mobilePage===1}

                    onClick={()=>setMobilePage(p=>p-1)}

                    className="
                    px-4
                    py-2
                    border
                    rounded
                    disabled:opacity-40
                    "

                    >

                    Previous

                    </button>

                    <span>

                    Page {mobilePage}

                    of

                    {mobileTotalPages}

                    </span>

                    <button

                    disabled={mobilePage===mobileTotalPages}

                    onClick={()=>setMobilePage(p=>p+1)}

                    className="
                    px-4
                    py-2
                    border
                    rounded
                    disabled:opacity-40
                    "

                    >

                    Next

                    </button>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default CourseReport;